import { render, staticRenderFns } from "./AssignmentMaterial.vue?vue&type=template&id=04809766&"
import script from "./AssignmentMaterial.vue?vue&type=script&lang=js&"
export * from "./AssignmentMaterial.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentMaterial.vue?vue&type=style&index=0&id=04809766&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports